import { Button } from '@aon/aon-tws-common-ui';
import * as React from 'react';
import _ from 'lodash';
import { DuplicateEmailsWarning } from '../../../components/common/warnings';
import Constants from '../../../constants';
import { ReadonlyHierarchy } from '../../../containers/hierarchy/ReadonlyHierarchy';
import ContentConstants from '../../../contentConstants';
import { IAudience, IDistributionContactActionCreators, ISurveyParticipantActionCreators, SurveyStatusType } from '../../../models';
import { IDistributionContactState } from '../../../store/DistributionContactStore';
import { IDistributionFileState } from '../../../store/DistributionFileStore';
import { IDistributionHierarchyState } from '../../../store/DistributionHierarchyStore';
import { ISurveyParticipantState } from '../../../store/SurveyParticipantStore';
import { CardLayout, HeaderButtonContainer } from '../../common';

export type IAdminHrisParticipantsProps = {
	audiences: IAudience[];
	surveyStatus?: SurveyStatusType;
	surveyId: number;
	audienceId: number;
	selectedHierarchyId?: string;
	initializingHierarchy: boolean;
	GetHrisHierarchies: (externalHrisId: string) => void;
	GetDistributionHierarchy: (surveyId: number, audienceId: number) => void;
	DownloadDistributionList: (surveyId: number, audienceId: number) => void;

	Navigate: (route: string) => void;
} & IDistributionHierarchyState &
	IDistributionFileState &
	IDistributionContactState &
	IDistributionContactActionCreators &
	ISurveyParticipantState &
	ISurveyParticipantActionCreators;

export class AdminHrisParticipants extends React.PureComponent<IAdminHrisParticipantsProps> {
	public constructor(props: IAdminHrisParticipantsProps) {
		super(props);

		this.showDuplicateParticipants = this.showDuplicateParticipants.bind(this);
	}

	public componentDidMount() {
		if (this.props.surveyId && this.props.audienceId) {
			this.props.GetDistributionHierarchy(this.props.surveyId, this.props.audienceId);

			this.props.GetSurveyParticipantsCount(
				this.props.surveyId,
				this.props.audienceId,
				'', // Sending this empty since we need to check the duplicates across DL
				true,
			);
		}

		if (this.props.distributionHierarchy?.externalHrisId) {
			this.props.GetHrisHierarchies(this.props.distributionHierarchy?.externalHrisId);
		}
	}

	public render() {
		const {
			surveyId,
			audienceId,
			audiences,
			isDownloading,
			selectedHierarchyId,
			initializingHierarchy,
			selectionCriteria,
			contactsCount,
			surveyStatus,
			DownloadDistributionList,
		} = this.props;

		const distributionType = _.find(audiences, (a) => a.audienceId === audienceId)?.distributionType;

		const headerButton = (
			<HeaderButtonContainer className='tws-export-participants-button'>
				<Button disabled={isDownloading} onClick={() => DownloadDistributionList(surveyId, audienceId)}>
					{ContentConstants.SURVEY_ADMIN_PARTICIPANTS_EXPORT}
				</Button>
			</HeaderButtonContainer>
		);

		return (
			<>
				<CardLayout loading={initializingHierarchy} title={ContentConstants.SURVEY_ADMIN_ACTION_HIERARCHY_VIEW} header={headerButton}>
					<DuplicateEmailsWarning
						duplicateContactsCount={contactsCount}
						surveyStatus={surveyStatus!}
						distributionType={distributionType!}
						onShowDuplicatesClick={this.showDuplicateParticipants}
					/>
					<ReadonlyHierarchy hierarchyId={selectedHierarchyId} includeOwners={false} selectionCriteria={selectionCriteria} />
				</CardLayout>
			</>
		);
	}

	public showDuplicateParticipants() {
		this.props.Navigate(
			`${Constants.ROUTE_SURVEY_ADMIN}/${this.props.surveyId}/audience/${this.props.audienceId}/participants${Constants.SHOW_ONLY_DUPLICATES_QUERY_STRING}`,
		);
	}
}
